module.exports = __webpack_public_path__ + "media/ryu.ae6116b8.wav";